import { render, staticRenderFns } from "./MenuDisplay.vue?vue&type=template&id=7a0b901c&scoped=true&"
import script from "./MenuDisplay.vue?vue&type=script&lang=js&"
export * from "./MenuDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a0b901c",
  null
  
)

export default component.exports